import React from 'react'
import { features } from './data-renderer/WhatMakesData'
import FeatureCard from '../../components/FeatureCard'

function WhatMakes() {
    return (
        <div className='hidden md:block px-6 pt-20 lg:pt-[120px] lg:px-[120px]'>
            <h1 className="text-[40px] leading-[54px] font-semibold text-center mb-6 lg:mb-10 text-[#27506E]">
                What Makes Us Different
            </h1>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6'>
                {features.map((feature, index) => (
                    <FeatureCard key={index} {...feature} />
                ))}
            </div>
        </div>
    )
}

export default WhatMakes